<template>
    <div>
        <div class="headlin-text" style="padding-bottom: 4%;">Forgot Password?</div>
        <div>
            <div>Check you email. Password reset link has been sent.</div>
        </div>
        <div>
            <button class="adway-btn-class" @click="clickLink">
              <span class="btn__text__bold">Home</span>
            </button>
            <router-link class="router-link-home" to="/" style="display: none;">Home</router-link>
        </div>
    </div>
</template>

<script>
export default {
  name: 'ConfirmPage',
  methods: {
    clickLink () {
      this.$router.push('/')
    }
  }
}
</script>
